<div *ngIf="loading || (loading$ | async)" class="app-loading-spinner">
  <div class="position-wrapper">
    <gms-logo-spinner></gms-logo-spinner>
  </div>
</div>
